import React from 'react';
import { Loader2 } from 'lucide-react';
import { useAuthCallback } from '../../hooks/useAuthCallback';

const AuthCallback = () => {
  useAuthCallback();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-slate-900 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-white">
        <Loader2 className="w-10 h-10 animate-spin" />
        <span className="text-lg font-medium">Completing sign in...</span>
      </div>
    </div>
  );
};

export default AuthCallback;
